import { useSelector } from 'react-redux';
import { loggedInUser } from '../../../untidy/redux/selectors';
import { useRootContext } from './index';

export function useIsMaintenanceMode() {
  const text = useMaintenanceModeText();
  return !!text;
}

export function useMaintenanceModeText() {
  const { maintenanceModeText } = useRootContext();
  return maintenanceModeText;
}

export function useIsFullMaintenanceMode() {
  const text = useMaintenanceModeText();
  return isFullMaintenanceMode(text);
}

export function isFullMaintenanceMode(text: string | undefined) {
  const maintenanceModeType = getMaintenanceType(text);
  return maintenanceModeType === MaintenanceType.FULL_MAINTENANCE;
}

export function useDisableSearch() {
  const text = useMaintenanceModeText();
  const user = useSelector(loggedInUser);

  return !user && getMaintenanceType(text) === MaintenanceType.DISABLE_SEARCH;
}

function getMaintenanceType(text: string | undefined) {
  if (!text) {
    return undefined;
  }
  const textTrimmed = text.toString().trim();
  switch (textTrimmed) {
    case 'DISABLE_SEARCH':
      return MaintenanceType.DISABLE_SEARCH;
    default:
      return MaintenanceType.FULL_MAINTENANCE;
  }
}

enum MaintenanceType {
  FULL_MAINTENANCE,
  DISABLE_SEARCH,
}

export const searchIsDisabledText = `Search is temporarily disabled from non-customers due to unexpectedly high traffic to our site.`;
